<script>

import FrontBusiness from "@/business/FrontBusiness";
import IndicadorBusiness from "@/business/indicadores/IndicadorBusiness.js";
import IndicadorPessoalBusiness from "@/business/indicadores/IndicadorPessoalBusiness";
import SocioBusiness from "@/business/indicadores/SocioBusiness";
import IndicadorRealBusiness from "@/business/indicadores/IndicadorRealBusiness";
import FirmaPendenciasHelper from "@/business/indicadores/FirmaPendenciasHelper";
import Utils from "@/commons/Utils";
import AlertMessage from "@/components/alert/AlertConstMessage";
import AlertOcorrencia from "@/components/alert/AlertOcorrencia.vue";
import DetalhesIndicadorPessoal from "@/components/IndicadorPessoal/Detalhes/DetalhesIndicadorPessoal";
import FormIndicadorPessoal from "@/components/IndicadorPessoal/Form/FormIndicadorPessoal";
import Card from "@/components/Layout/components/Card.vue";

import EnvolvidosAto from "@/views/Protocolo/Atos/Ato/EnvolvidosAto";
import draggable from 'vuedraggable'
import ChecklistProcessamentoBusiness from "@/business/ChecklistProcessamentoBusiness";
import NotaExigencia from "@/components/Checklist/NotaExigencia";
import Toggle from "@/components/Layout/components/Toggle";
import FracaoTransferenciaImovelBusiness from "@/business/protocolo/FracaoTransferenciaImovelBusiness";
import EventBus from "@/commons/EventBus";
import CalcularPorcentagem from "@/views/Protocolo/Atos/Ato/CalcularPorcentagem";
import AtoBusiness from "@/business/protocolo/AtoBusiness";
import CardTable from "@/components/Layout/components/CardTable.vue";
import FirmaBotoes from "@/components/IndicadorPessoal/Detalhes/Tabelionato/FirmaBotoes.vue";
import EnvolvidoBib from "./EnvolvidoBib";

export default {

  name: "Envolvidos",

  components: {
    FirmaBotoes,
    CardTable,
    AlertOcorrencia,
    AlertIndisponibilidade: () => import("@/components/alert/AlertIndisponibilidade"),
    AlertPep: () => import("@/components/alert/AlertPep"),
    Card, Toggle, draggable,
    ResponderChecklist: () => import("@/components/Protocolo/ResponderChecklist.vue"),
    EnvolvidoBib,
  },

  props: {
    'ato': {type: Object},
    'edicao': {type: Boolean},
    'protocolo': {type: Object},
    'ficha': {type: Object},
    'documentos': {type: Array},
    tipo: {type: String, default: 'ato'},
    checklist: {type: Array, default: () => []},
    ocultarComunicar: {type: Boolean, default: false},
    isNotaDistribuicaoRjCusta: {type: Boolean, default: false},
  },

  beforeMount() {
    this.papeisList = IndicadorRealBusiness.getCachedPapeisByDominio(this.dominio);
    this.proprietarios = this.ficha?.proprietarios || [];
    Utils.orderFields(this.ato?.envolvidos, ['ordem', 'nome']);
    this.ordenar(true);
  },

  created() {
    this.getInventariante();
    this.getCnib();
    this.getBib();
    this.getRepresentante();
    EventBus.$on('ADD-SUGESTAO-ENVOLVIDOS', this.addSugestaoEnvolvidos);
  },

  data() {
    return {
      label: '',
      form: {},
      isDocumentoValido: false,
      papeisComFracao: ['ADQUIRENTE', 'TRANSMITENTE', 'DEVEDOR','GARANTIDOR', 'CREDOR', 'CEDENTE', 'CESSIONARIO', 'PROMITENTE_VENDEDOR', 'PROMITENTE_COMPRADOR', 'FIEL_DEPOSITARIO'],
      papeisParticipacaoDoi: ['ADQUIRENTE', 'TRANSMITENTE', 'CEDENTE', 'CESSIONARIO', 'PROMITENTE_VENDEDOR', 'PROMITENTE_COMPRADOR'],
      papeisList: [],
      proprietarios: [],
      indicadorPossuiIndisponibilidade : AlertMessage.indicadorPossuiIndisponibilidade(),
      indicadorPossuiOcorrencias : AlertMessage.indicadorPossuiOcorrencias(),
      mostrarChecklistEnvolvido: null,
      validacaoFracaoEnvolvido: [],
      processando: false,
      papeisTransmitentes:['TRANSMITENTE','CEDENTE','PROMITENTE_VENDEDOR'],
      papeisAdquirentes:['ADQUIRENTE','CESSIONARIO','PROMITENTE_COMPRADOR'],
      docRepresentante:null,
      categoriasEnvolvido: [
        { id: 'OUTORGANTE', nome: 'Outorgante' },
        { id: 'OUTORGADO', nome: 'Outorgado' },
        { id: 'INTERVENIENTE', nome: 'Interveniente' },
        { id: '', nome: 'Nenhum' }
      ],
      tiposAssinatura: [
        { id: 'ASSINA_FISICAMENTE', nome: 'Assina Fisicamente' },
        { id: 'ASSINA_DIGITALMENTE', nome: 'Assina Digitalmente' },
        { id: 'ASSINA_A_ROGO', nome: 'Assina a Rogo' },
        { id: 'NAO_ASSINA', nome: 'Não Assina' }
      ],
      dedosAssinatura: [
        { id: 'POLEGAR_DIREITO', nome: 'Polegar Direito' },
        { id: 'INDICADOR_DIREITO', nome: 'Indicador Direito' },
        { id: 'MEDIO_DIREITO', nome: 'Médio Direito' },
        { id: 'ANELAR_DIREITO', nome: 'Anelar Direito' },
        { id: 'MINIMO_DIREITO', nome: 'Mínimo Direito' },
        { id: 'POLEGAR_ESQUERDO', nome: 'Polegar Esquerdo' },
        { id: 'INDICADOR_ESQUERDO', nome: 'Indicador Esquerdo' },
        { id: 'MEDIO_ESQUERDO', nome: 'Médio Esquerdo' },
        { id: 'ANELAR_ESQUERDO', nome: 'Anelar Esquerdo' },
        { id: 'MINIMO_ESQUERDO', nome: 'Mínimo Esquerdo' }
      ]
    }
  },

  computed: {

    papelComFracao() {
      if (this.tipo !== 'ato') return null;
      return this.ato.envolvidos
        .find(e => this.papeisComFracao.includes(e.papel));
    },

    transmitentes() {
      return this.ato.envolvidos
        .reduce((total, e) => total + (e.papel == 'TRANSMITENTE' || e.papel == 'CEDENTE' || e.papel == 'PROMITENTE_VENDEDOR' ? (e.fracao ? parseFloat(e.fracao) : 0) : 0), 0);
    },

    adquirentes() {
      return this.ato.envolvidos
        .reduce((total, e) => total + (['ADQUIRENTE', 'CESSIONARIO', 'PROMITENTE_COMPRADOR'].includes(e.papel) ? (e.fracao ? parseFloat(e.fracao) : 0) : 0), 0);
    },

    dominio(){
      return this.ato?.tipoServico?.dominio || this.protocolo?.dominio;
    },

    adquirenteValidaPorcentagemDOI() {
      return this.ato.envolvidos
        .find(e => e.ajusteDoi === true && ['ADQUIRENTE','CESSIONARIO','PROMITENTE_COMPRADOR'].includes(e.papel)) ? true : false;
    },

    transmitenteValidaPorcentagemDOI() {
      return this.ato.envolvidos
        .find(e => e.ajusteDoi === true && ['TRANSMITENTE','CEDENTE','PROMITENTE_VENDEDOR'].includes(e.papel)) ? true : false;
    },

    papeis() {
      const proibidos = this.ato.tipoServico?.opcoes?.papeisProibidos || [];
      return this.papeisList.filter(p => !proibidos.includes(p.id))
    },

    exibirFracao() {
      return ['MATRICULA', 'TRANSCRICAO', 'TORRENS', 'REGISTRO_TD'].includes(this.ato.livro);
    },

    exibirParticipacaoDoi(){
      return this.ato.tipoServico.opcoes.tipoTransacaoDoi !== 'NENHUM' && this.ato.doi?.gerarDoi !== false && !this.isCustaAdicional;
    },

    isCustaAdicional() {
      return this.tipo == 'custa-adicional';
    },

    unidadeArea(){
      return this.ficha?.medidaArea ? FrontBusiness.getLabel(this.ficha?.medidaArea, IndicadorRealBusiness.getMedidas()) : '';
    },

    isAberturaFirma() {
      return this.isCustaAdicional && this.ato.tipoServico.opcoes.tipoAto === 'ABERTURA_FIRMA';
    },

    isAtalhosPessoa() {
      return this.isCustaAdicional && ['ABERTURA_FIRMA', 'RECONHECIMENTO_FIRMA'].includes(this.ato.tipoServico.opcoes.tipoAto);
    },

    isProtocoloEspecialNotas() {
      return ['ESCRITURA', 'PROCURACAO', 'SUBSTABELECIMENTO', 'TESTAMENTO', 'ATA_NOTARIAL'].includes(this.dominio);
    },

    filtrosEnvolvidos() {
      const filtros = {};
      if (this.ato?.tipoServico?.opcoes?.filtrarServentiaExtrajudicial) {
        filtros.filtroServentiaExtrajudicial = true;
      }
      if (this.isCustaAdicional && this.ato?.tipoServico?.opcoes?.tipoAto === 'RECONHECIMENTO_FIRMA') {
        const configTipoReconhecimento = this.ato?.tipoServico?.opcoes?.tipoReconhecimento;
        const tipoReconhecimentoEfetivo = configTipoReconhecimento === 'SELECIONAR_NO_SERVICO'
          ? this.ato?.tipoReconhecimento
          : configTipoReconhecimento;
        if (tipoReconhecimentoEfetivo !== 'SINAL_PUBLICO') {
          filtros.filtroSomenteComFirma = true;
        }
      }
      return filtros;
    },

    exibirPapel() {
      return !this.isCustaAdicional || this.isNotaDistribuicaoRjCusta;
    },

    exibirBib() {
      return this.$root.isEstadoRJ;
    },

    exibirComunicar() {
      return this.protocolo?.dadosDistribuicao?.comunicarDistribuidor && this.$root.config.estado === 'RJ' && this.tipo === 'ato' && !this.ocultarComunicar;
    },

    papelPadrao() {
      if (this.isCustaAdicional) {
        return this.isNotaDistribuicaoRjCusta ? this.papeis?.[0]?.id : null;
      }
      return this.papeis?.[0]?.id;
    }

  },

  watch: {
    'ato.envolvidos': function () {
      if (this.ato.envolvidos) {
        this.ato.envolvidos.forEach(envolvido => {
          if (envolvido.categoriaEnvolvido === null || envolvido.categoriaEnvolvido === undefined) {
            this.$set(envolvido, 'categoriaEnvolvido', '');
          }
        });
      }

      this.setMedidaAreaEnvolvidos();
      this.getInventariante();
      this.getCnib();
      this.getBib();
      this.getRepresentante();
      this.calculoInicialParticipacaoDoi();
    }
  },

  methods: {
    async getInventariante() {
      await this.ato.envolvidos.map(async envolvido => {
        this.$set(envolvido, 'exibicao', this.inventarianteExibicao(envolvido));
        this.$set(envolvido, 'inventarianteVersao', envolvido?.inventarianteVersao? {id: envolvido?.inventarianteVersao?.id, nome: envolvido?.inventarianteVersao?.nome} : {});
        this.$set(envolvido, 'editandoInventariante', await this.validarDocumentos(envolvido, true));
      });
    },

    async getRepresentante(){
      await Promise.all(this.ato.envolvidos.map(async envolvido => {
        this.$set(envolvido, 'editandoRepresentante', false);
        if (this.dominio === 'SERVICO_TN' && envolvido.tipoPessoa === 'JURIDICA') {
          try {
            const socios = await SocioBusiness.listarRepresentantes(envolvido.indicadorPessoalId);
            const salvos = Array.isArray(envolvido.representantes) ? envolvido.representantes : [];
            this.$set(envolvido, 'representantes', socios.map(s => {
              const salvo = salvos.find(r => r.indicadorPessoalVersaoId === s.indicadorPessoalVersaoId || r.documento === s.documento);
              return {
                nome: s.nome,
                documento: s.documento,
                indicadorPessoalVersaoId: s.indicadorPessoalVersaoId,
                principal: salvo ? salvo.principal : false,
                tipoVinculo: s.tipoVinculo,
                nomeTipoVinculo: s.nomeTipoVinculo
              };
            }));
          } catch (e) {
            console.error('Erro ao carregar representantes do quadro societário', e);
          }
          this.$set(envolvido, 'editandoRepresentante', true);
        }
        this.representantePrincipalExibicao(envolvido);
      }));
    },

    async getCnib() {
      await this.ato.envolvidos.map(async envolvido => {
        this.$set(envolvido, 'consultaCnib', envolvido.consultaCnib);
        this.$set(envolvido, 'cnib', envolvido.consultaCnib);
        this.$set(envolvido, 'dataConsultaCnib', envolvido.dataConsultaCnib);
        this.$set(envolvido, 'resultadoConsultaCnib', envolvido.resultadoConsultaCnib);
      });
    },

    async getBib() {
      await this.ato.envolvidos.map(async envolvido => {
        this.$set(envolvido, 'bib', envolvido.consultaBib);
        this.$set(envolvido, 'consultaBib', envolvido.consultaBib);
        this.$set(envolvido, 'dataConsultaBib', envolvido.dataConsultaBib);
        this.$set(envolvido, 'gratuitoBib', envolvido.gratuitoBib);
        this.$set(envolvido, 'lei11441Bib', envolvido.lei11441Bib);
        const consultas = Array.isArray(envolvido.consultasBib) ? envolvido.consultasBib : [];
        if (!consultas.length && envolvido.consultaBib) {
          consultas.push({
            numero: envolvido.consultaBib,
            data: envolvido.dataConsultaBib || null,
            gratuito: envolvido.gratuitoBib ?? null,
            lei11441: envolvido.lei11441Bib ?? null
          });
        }
        consultas.forEach(c => {
          if (c) this.$set(c, 'dataAutomatica', Utils.extrairDataConsultaBib(c.numero));
        });
        this.$set(envolvido, 'consultasBib', consultas);
      });
    },

    validacaoEnvolvido() {
      this.proprietarios.forEach(proprietario => {
        this.ato.envolvidos?.forEach((envolvido) => {
          let versaoDoProprietario = proprietario.indicadorPessoalVersao;
          let versaoDoEnvolvido = envolvido.indicadorPessoalVersao;
          if(versaoDoProprietario && versaoDoProprietario.documento === versaoDoEnvolvido.documento && versaoDoProprietario.indicadorPessoalId !== versaoDoEnvolvido.indicadorPessoalId && !Utils.isEmptyNullOrUndefined(versaoDoEnvolvido.documento)){
            envolvido.ALERTA_DOCUMENTO = `O proprietário (${versaoDoProprietario.nome}) possui o mesmo ${envolvido.tipoPessoa === 'FISICA' ? 'CPF' : 'CNPJ'} que o envolvido (${envolvido.nome}) porém são indicadores diferentes`;
          }
        });
      });
    },

    ordenar(skipEmit = false) {

      this.$set(this.ato, 'envolvidos', this.ato.envolvidos.map((e, i) => {
        e.ordem = i + 1;
        return e;
      }));

      this.validacaoEnvolvido();

      if (!skipEmit) {
        this.$emit('checklist');
      }

    },

    async emitChange(i) {
      this.$emit('change-editor', {}, null, [true, false]);
      await this.$refs?.checklist?.[i]?.process();
    },

    remover(idx, atualizar = true) {
      this.ato.envolvidos.splice(idx, 1);
      this.ordenar();
      this.recalcularParticipacaoDoi();
      if (atualizar) this.emitChange();
    },

    duplicar(envolvido) {
      this.selecionarEnvolvido(envolvido?.indicadorPessoalVersao)
    },

    async salvarAssinatura(envolvido) {
      try {
        if (envolvido.tipoAssinatura !== 'ASSINA_A_ROGO') {
          envolvido.dedoAssinatura = null;
        }
        if (envolvido.tipoAssinatura === 'NAO_ASSINA') {
          envolvido.dataAssinatura = null;
        }
        await AtoBusiness.atualizarAssinaturaEnvolvido(this.protocolo.id, this.ato.id, envolvido.id, {
          tipoAssinatura: envolvido.tipoAssinatura,
          dedoAssinatura: envolvido.dedoAssinatura,
          dataAssinatura: envolvido.dataAssinatura
        });
        FrontBusiness.showSuccess('', 'Assinatura atualizada com sucesso');
      } catch (e) {
        FrontBusiness.showError('', e);
      }
    },

    atualizar(i, envolvido) {
      this.remover(i, false);
      this.ato.envolvidos.splice(i, 0, envolvido);
      this.ordenar();
    },

    async editar(envolvido, i) {

      if (!this.edicao || !envolvido?.indicadorPessoalId) {
        return;
      }

      let retorno = await FrontBusiness.openModal(FormIndicadorPessoal, {versaoId: envolvido.indicadorPessoalVersao.id});
      if (retorno) {
        this.atualizar(i, {
          exigencias: this.ato.envolvidos[i].exigencias,
          indices: this.ato.envolvidos[i].indices,
          papel: this.ato.envolvidos[i]?.papel || this.papelPadrao,
          categoriaEnvolvido: this.ato.envolvidos[i]?.categoriaEnvolvido ?? '',
          fracao: this.ato.envolvidos[i].fracao || 0,
          participacaoDoi: this.ato.envolvidos[i].participacaoDoi || 0,
          area: this.ato.envolvidos[i].area || 0,
          ajusteDoi: this.ato.envolvidos[i].ajusteDoi || false,
          exibicao: this.ato.envolvidos[i].exibicao,
          exibicaoRepresentantePrincipal:this.ato.envolvidos[i].exibicaoRepresentantePrincipal,
          consultaCnib: this.ato.envolvidos[i].consultaCnib,
          dataConsultaCnib: this.ato.envolvidos[i].dataConsultaCnib,
          resultadoConsultaCnib: this.ato.envolvidos[i].resultadoConsultaCnib,
          consultaBib: this.ato.envolvidos[i].consultaBib,
          dataConsultaBib: this.ato.envolvidos[i].dataConsultaBib,
          gratuitoBib: this.ato.envolvidos[i].gratuitoBib,
          lei11441Bib: this.ato.envolvidos[i].lei11441Bib,
          consultasBib: this.ato.envolvidos[i].consultasBib || [],
          indicadorPessoalVersao: retorno,
          tipoPessoa: retorno.tipoPessoa,
          nome: retorno.nome,
          indicadorPessoalId: retorno.indicadorPessoalId,
          inventarianteVersao: this.ato.envolvidos[i].inventarianteVersao,
          inventariante: this.ato.envolvidos[i].inventariante,
          representantes:this.ato.envolvidos[i].representantes,
          tipoAssinatura: this.ato.envolvidos[i].tipoAssinatura,
          dedoAssinatura: this.ato.envolvidos[i].dedoAssinatura,
          dataAssinatura: this.ato.envolvidos[i].dataAssinatura,
          comunicar: this.ato.envolvidos[i].comunicar,
        });
      }

    },

    verificarFracao(envolvido, i) {
      if (envolvido.fracao > 100) {
        this.ato.envolvidos[i].fracao = 100;
      }
      this.ordenar();
    },

    verificarArea(envolvido, i) {
      let total = this.ficha?.area;
      if (total && envolvido.area > total) {
        this.ato.envolvidos[i].area = total;
      }
      this.ordenar();
    },

    verificarConjuge(conjuge) {
      let notifica = true;
      this.ato.envolvidos.findIndex(envolvido => {
        if (envolvido.indicadorPessoalVersao.id === conjuge.conjuge_id) notifica = false;
      });
      if (notifica) {
        this.confirmarConjuge(undefined, conjuge.conjuge_id);
      }
    },

    async confirmarConjuge(close, conjuge) {
      let result = FrontBusiness.showConfirmacao("Envolvido possui cônjuge", "Deseja adicioná-lo ao ato?").then(async r => {
        if (r.value) {
          let indicador = await IndicadorPessoalBusiness.getVersaoById(conjuge);
          let envolvidos = {};
          let campos = ["possuiParticipacaoEstrangeira", "telefone", "tipoPessoa", "conjuge_id", "lote", "indicadorPessoalId", "quadra", "documento", "nome", "comercial", "celular", "id", "email", "versao"]
          for (let i = 0; i < campos.length; i++) {
            let campo = campos[i];
            envolvidos[campo] = indicador[campo];
          }
          this.selecionarEnvolvido(envolvidos);
          return (close ? true : false);
        } else if (r.dismiss === 'cancel') {
          return false;
        } else {
          return true;
        }
      }).catch(this.showError).finally(() => {
        FrontBusiness.setFocus(this.$el, 'buscar-pessoa input');
      });

      return result
    },

    async selecionarEnvolvido(envolvido, fracao = 0, area = 0, papel = null, verificarConjuge = true) {
      if (!envolvido?.indicadorPessoalId) {
        return;
      }
      if (envolvido.conjuge_id && verificarConjuge) this.verificarConjuge(envolvido);
      if (envolvido.inventarianteId) this.$set(envolvido, 'inventarianteVersao', await IndicadorPessoalBusiness.getVersaoById(envolvido.inventarianteId));
      this.$set(envolvido, 'exibicao', this.inventarianteExibicao(envolvido));
      this.representantePrincipalExibicao(envolvido);
      await this.validarDocumentos(envolvido, true);

      const novoEnvolvido = {
        indicadorPessoalVersao: envolvido,
        papel: papel || this.papelPadrao,
        categoriaEnvolvido: '',
        fracao: fracao,
        area,
        medidaArea: this.ficha?.medidaArea,
        ajusteDoi: false,
        versao: null,
        exibicao: envolvido.exibicao,
        exibicaoRepresentantePrincipal:envolvido.exibicaoRepresentantePrincipal,
        ordem: 1000,
        tipoPessoa: envolvido.tipoPessoa,
        nome: envolvido.nome,
        indicadorPessoalId: envolvido.indicadorPessoalId,
        representantes: Array.isArray(envolvido?.representantes) ? envolvido.representantes : [],
        inventariante:envolvido.inventariante,
        inventarianteVersao: envolvido.inventarianteVersao || {},
        inventarianteDocumentoInvalido: envolvido.inventarianteDocumentoInvalido,
        tipoAssinatura: null,
        dedoAssinatura: null,
        dataAssinatura: null,
        consultaBib: null,
        dataConsultaBib: null,
        gratuitoBib: null,
        lei11441Bib: null,
        consultasBib: [],
        comunicar: true,
      };

      this.ato.envolvidos.push(novoEnvolvido);

      if (this.dominio === 'SERVICO_TN' && envolvido.tipoPessoa === 'JURIDICA') {
        try {
          const socios = await SocioBusiness.listarRepresentantes(envolvido.indicadorPessoalId);
          this.$set(novoEnvolvido, 'representantes', socios.map(s => ({
            nome: s.nome,
            documento: s.documento,
            indicadorPessoalVersaoId: s.indicadorPessoalVersaoId,
            principal: false,
            tipoVinculo: s.tipoVinculo,
            nomeTipoVinculo: s.nomeTipoVinculo
          })));
          this.representantePrincipalExibicao(novoEnvolvido);
          this.$set(novoEnvolvido, 'editandoRepresentante', true);
        } catch (e) {
          console.error('Erro ao carregar representantes do quadro societário', e);
        }
      }

      this.ordenar();
      this.$emit('change-editor', {}, `ENVOLVIDO_PAPEL_${envolvido.indicadorPessoalId}`, [true, false]);
    },

    async sugerirEnvolvidos() {
      await FrontBusiness.openModal(EnvolvidosAto, {
        protocolo: this.protocolo?.id,
        ficha: this.ficha,
        proprietarios: this.proprietarios,
        atuais: this.ato?.envolvidos,
        buscarEnvolvidosCustasAdicionais: !this.isCustaAdicional,
        deduplicarSugestoes: this.isCustaAdicional
      });
    },

    async addSugestaoEnvolvidos(selecionados) {
      if (selecionados) {
        let papel = this.papeis[0]?.id;
        let transmitente = this.papeis.find(e => e.id == 'TRANSMITENTE') ? 'TRANSMITENTE' : papel;
        selecionados.forEach(selecionado => {
          if (selecionados.length === 1) {
            selecionado.indicadorPessoalVersao.conjuge_id = selecionado.indicadorPessoalVersao.conjuge?.id || selecionado.indicadorPessoalVersao.conjuge;
          }
          delete selecionado.indicadorPessoalVersao.conjuge
          this.selecionarEnvolvido(selecionado.indicadorPessoalVersao, selecionado.fracao || 0, selecionado.area || 0, selecionado.fracao ? transmitente : papel, false);
        });
      }
    },

    // Inventariante
    inventarianteExibicao(envolvido) {
      return `${envolvido?.inventarianteVersao?.nome ? `${envolvido?.inventarianteVersao?.nome} - ` : ''}${envolvido.inventariante}`;
    },

    selecionarRepresentantePrincipal(envolvido,selectedRepresentante) {
        envolvido.representantes.forEach(representante => {
          if (representante !== selectedRepresentante) {
            representante.principal = false;
          }
        });
        this.representantePrincipalExibicao(envolvido);
    },

    selecionarRepresentanteServicoTn(envolvido) {
      this.representantePrincipalExibicao(envolvido);
    },

    representantePrincipalExibicao(envolvido) {
      let listaRepresentantes = envolvido.representantes || [];
      let exibicao = '';
      if(listaRepresentantes.length >0){
        if (this.dominio === 'SERVICO_TN') {
          let repsSelecionados = listaRepresentantes.filter(re => re.principal);
          exibicao = repsSelecionados.map(rep => {
            if (rep?.nomeTipoVinculo) {
              return `${rep?.nome || ''} - ${rep.nomeTipoVinculo}`;
            }
            return `${rep?.nome ? `${rep?.nome} - ` : ''} ${rep.documento ? rep.documento : ''}`;
          }).join(', ');
        } else {
          let repPrincipal = listaRepresentantes.find(re => re.principal) || listaRepresentantes[0];
          exibicao = `${repPrincipal?.nome ? `${repPrincipal?.nome} - ` : ''} ${repPrincipal.documento ? repPrincipal.documento : ''}`;
        }
      }
      this.$set(envolvido, 'exibicaoRepresentantePrincipal', exibicao);
    },

    editInventariante(envolvido) {
      if (!this.edicao)  return;
      if(!envolvido.editandoInventariante){
        this.ato.envolvidos.forEach(e=>{
          this.$set(e, 'editandoInventariante', false);
        })
      }
      this.$set(envolvido, 'editandoInventariante', !envolvido.editandoInventariante);
    },

    getExibirInventariante(envolvido){
      if(!envolvido.indicadorPessoalVersao.falecido){
        envolvido.inventariante=null;
        envolvido.inventarianteVersao=null;
      }
      return envolvido.indicadorPessoalVersao.falecido;
    },


    // Representante
    editRepresentante(envolvido) {
      if (envolvido.representantes.length === 0 && !this.edicao) return;
      if (!envolvido.editandoRepresentante) {
        this.ato.envolvidos.forEach(e => {
          this.$set(e, 'editandoRepresentante', false);
        });
      }
      this.$set(envolvido, 'editandoRepresentante', !envolvido.editandoRepresentante);
    },

    adicionarRepresentante(envolvido) {
      if (!this.edicao) return;
      this.ato.envolvidos.forEach(e => {
        this.$set(e, 'editandoRepresentante', false);
      });
      this.$set(envolvido, 'editandoRepresentante', true);
      this.$nextTick(() => {
        const buscarRef = this.$refs.buscarRepresentante?.[0];
        buscarRef?.$el?.querySelector('input')?.focus();
      });
    },

    async salvarAssinaturaRepresentante(representante) {
      if (!representante.id) return;
      try {
        await AtoBusiness.atualizarAssinaturaRepresentante(this.protocolo.id, this.ato.id, representante.id, {
          tipoAssinatura: representante.tipoAssinatura,
          dedoAssinatura: representante.dedoAssinatura,
          dataAssinatura: representante.dataAssinatura
        });
        FrontBusiness.showSuccess('', 'Assinatura do representante atualizada com sucesso');
      } catch (e) {
        FrontBusiness.showError('', e);
      }
    },

    editHashCNIB(envolvido) {
      if (!this.edicao)  return;
      if(!envolvido.editandoHashCNIB) {
        this.ato.envolvidos.forEach(e => {
          this.$set(e, 'editandoHashCNIB', false);
        })
      }
      this.$set(envolvido, 'editandoHashCNIB', !envolvido.editandoHashCNIB);
    },

    async copyHashCNIB(envolvido) {
      let r = await FrontBusiness.showConfirmacao("", "Deseja confirmar a cópia desse hash para este envolvido em todos os atos?").catch(this.showError);
      if (r.value) {
        let result = await AtoBusiness.copiarCNIB(this.protocolo.id, envolvido)
          .catch(e => FrontBusiness.showError('', e?.message || 'Ocorreu um erro ao tentar copiar hash CNIB'));
        if (result) {
          FrontBusiness.showSuccess('', 'Hash CNIB copiado com sucesso');
        }
      } else if (r.dismiss === 'cancel') {}
    },

    cnibSubStr(envolvido){
      if (envolvido.consultaCnib.length >= 100) {
        return envolvido.consultaCnib.substr(0, 99) + '...';
      } else {
        return envolvido.consultaCnib;
      }
    },

    async selecionarRepresentante(envolvido, indicador) {
      let representante = {
        documento:indicador.documento,
        nome:indicador.nome,
        indicadorPessoalVersaoId:indicador.id,
        envolvidoId:envolvido.id,
        principal:envolvido.representantes && envolvido.representantes.length === 0,
        papel: null,
        tipoAssinatura: null,
        dedoAssinatura: null,
        dataAssinatura: null
      };
      envolvido.representantes.push(representante);
      this.representantePrincipalExibicao(envolvido);
    },

    async validarSelecionarDocumentosRepresentante(envolvido) {
      const buscarRef = this.$refs.buscarRepresentante?.[0];
      let documento = buscarRef?.query;
      if(!documento){
        return FrontBusiness.showError('','Documento não informado');
      }
      let docLimpo = documento.replace(/[^a-zA-Z0-9]/g, '');
      let tipoRepresentante = docLimpo.length === 11 ? 'FISICA' : docLimpo.length === 14 ? 'JURIDICA' : null;
      if(!tipoRepresentante) {
        return FrontBusiness.showError('', 'Documento inválido!');
      }
      let msgInvalid = await IndicadorPessoalBusiness.validarDocumentos(tipoRepresentante, documento);
      if(msgInvalid){
        FrontBusiness.showError('', `O ${tipoRepresentante === 'FISICA' ? 'CPF' : 'CNPJ'} informado para o representante é inválido`);
      }

      let representante = {
        documento:documento,
        envolvidoId:envolvido.id,
        principal:envolvido.representantes && envolvido.representantes.length === 0,
        papel: null,
        tipoAssinatura: null,
        dedoAssinatura: null,
        dataAssinatura: null
      };
      envolvido.representantes.push(representante);
      this.representantePrincipalExibicao(envolvido);
      if (buscarRef) buscarRef.query = '';
    },

    removerRepresentante(envolvido,representante){
      let index =  envolvido.representantes.indexOf(representante);
      if(index !== -1){
        envolvido.representantes.splice(index, 1);
        this.representantePrincipalExibicao(envolvido);
      }
    },

    async selecionarInventariante(envolvido, indicador) {
      this.$set(envolvido, 'inventariante', indicador?.documento);
      this.$set(envolvido, 'inventarianteVersao', {id: indicador?.id, nome: indicador?.nome});
      this.$set(envolvido, 'exibicao', this.inventarianteExibicao(envolvido));
      await this.validarDocumentos(envolvido)
      if(!indicador) {
        this.$set(envolvido, 'inventarianteDocumentoInvalido', null);
      }
    },

    async removerCnib(envolvido, indicador) {
      if(!indicador) {
        this.$set(envolvido, 'cnib', null);
        this.$set(envolvido, 'consultaCnib', null);
      };
    },

    async validarDocumentos(envolvido, selecao = true) {
      let documentoInventariante = envolvido.inventariante;
      if (!selecao) documentoInventariante = this.$refs.buscar[0].query;
      let msgDocInvalido = await IndicadorPessoalBusiness.validarDocumentos('FISICA', documentoInventariante);
      if (!selecao) {
        this.$set(envolvido, 'inventariante', documentoInventariante);
        this.$set(envolvido, 'inventarianteVersao', {});
        this.$set(envolvido, 'exibicao', this.inventarianteExibicao(envolvido));
      }

      if (msgDocInvalido == null || (msgDocInvalido && (documentoInventariante == null || documentoInventariante === ""))) {
        this.$set(envolvido, 'inventirianteDocumentoInvalido', null);
      } else {
        this.$set(envolvido, 'inventarianteDocumentoInvalido', msgDocInvalido);
      }
    },

    async inserirCnib(envolvido, selecao = true) {
      if (!selecao) {
        this.$set(envolvido, 'cnib', envolvido.consultaCnib);
        this.$set(envolvido, 'consultaCnib', envolvido.consultaCnib);
      }
    },

    fecharOutrosBib(envolvidoAtual) {
      this.ato.envolvidos.forEach(e => {
        if (e !== envolvidoAtual) {
          this.$set(e, 'editandoHashBIB', false);
        }
      });
    },

    detalhes(pessoa, versao) {
      FrontBusiness.openModal(DetalhesIndicadorPessoal, {id: pessoa.indicadorPessoalId, versao, tipoAtoServico: this.ato.tipoServico?.opcoes?.tipoAto});
    },

    async detalhesRepresentante(representante) {
      if (!representante?.indicadorPessoalVersaoId) return;
      const versao = await IndicadorPessoalBusiness.getVersaoById(representante.indicadorPessoalVersaoId);
      this.detalhes(versao, representante.indicadorPessoalVersaoId);
    },

    async editarRepresentante(envolvido, representante) {
      if (!this.edicao || !representante?.indicadorPessoalVersaoId) return;
      const retorno = await FrontBusiness.openModal(FormIndicadorPessoal, {versaoId: representante.indicadorPessoalVersaoId});
      if (retorno) {
        this.$set(representante, 'indicadorPessoalVersaoId', retorno.id);
        this.$set(representante, 'nome', retorno.nome);
        this.$set(representante, 'documento', retorno.documento);
        this.representantePrincipalExibicao(envolvido);
        this.emitChange();
      }
    },

    async exibirExigencia(dto) {

      let indices = dto.indices;
      let exigencias = dto.exigencias;

      exigencias = await ChecklistProcessamentoBusiness.copilarExigencias(this.protocolo, {...dto, indices}, exigencias);
      await FrontBusiness.openModal(NotaExigencia, {exigencias: exigencias, protocolo: this.protocolo});

    },

    async change(e){
      let chave = this.chave(e);
      if(chave === this.mostrarChecklistEnvolvido){
        this.mostrarChecklistEnvolvido = null;
      } else {
        // await this.buscarAtosPorVersaoIndicadorPessoal(this.ficha.id, pessoa);
        this.mostrarChecklistEnvolvido = chave;
      }
    },

    chave(e) {
      return `envolvido-id-${e}`
    },

    async erroFracaoEnvolvido(){
      this.validacaoFracaoEnvolvido = [];
      let show = !(IndicadorBusiness.getLivro(this.ato?.ficha?.livro)?.grupo != 'INDICADOR_REAL' && this.ato?.tipoServico?.opcoes?.tipoAto === 'ABERTURA');
      if (show && this.ato?.tipoServico) {
        const validacao = await FracaoTransferenciaImovelBusiness.validarMargemTransferenciaAto(this.transmitentes, this.adquirentes, this.ato.tipoServico?.opcoes?.tipoAto === 'ABERTURA');
        if (validacao) {
          this.validacaoFracaoEnvolvido.push(validacao);
        }
      }
    },

    distribuirFracao() {
      let qtdAdquirentes = this.ato.envolvidos.reduce((total, e) => total + (['ADQUIRENTE','CESSIONARIO','PROMITENTE_COMPRADOR'].includes(e.papel) ? 1 : 0), 0);
      let fracaoDistribuir = (this.transmitentes/(qtdAdquirentes)).toFixed(2);
      this.ato.envolvidos.forEach(e => {
        if (['ADQUIRENTE','CESSIONARIO','PROMITENTE_COMPRADOR'].includes(e.papel)) {
          e.fracao = fracaoDistribuir;
        }
      })
      this.erroFracaoEnvolvido()
    },

    copyDocumento(text) {
      let textArea = document.createElement("textarea");
      textArea.style.position = 'fixed';
      textArea.style.top = 0;
      textArea.style.left = 0;
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
      } catch (err) {
        window.prompt("Copie para área de transferência: Ctrl+C e tecle Enter", text);
      }

      document.body.removeChild(textArea);
    },

    async calcularPorcentagem() {
      let envolvidos = await FrontBusiness.openModal(CalcularPorcentagem, {
        ficha: this.ficha,
        envolvidos: Utils.clone(this.ato?.envolvidos)
      });

      if (envolvidos) {
        this.$set(this.ato.dto, 'informarAreaEnvolvidos', true);
        this.$set(this.ato, 'envolvidos', envolvidos);
      }

    },

    setMedidaAreaEnvolvidos() {
      this.ato.envolvidos.forEach(e => {
        e.medidaArea = this.ato.dto.informarAreaEnvolvidos ? this.ficha?.medidaArea : null;
        e.area = this.ato.dto.informarAreaEnvolvidos ? e.area : null;
      });
      this.erroFracaoEnvolvido();
    },

    calcularFracao(e) {
      if (!this.ficha?.area) return;
      e.fracao = ((e.area || 0) * 100 / this.ficha?.area).toFixed(2);
    },

    participacao(e) {
      let doi = this.ato.tipoServico.opcoes.tipoTransacaoDoi !== 'NENHUM' && this.ato.doi?.gerarDoi !== false;
      if (!doi || e.fracao <= 0) return;
      let porcentagem = 0;
      if (this.papeisAdquirentes.includes(e.papel)) {
        porcentagem = this.adquirentes;
      } else if (this.papeisTransmitentes.includes(e.papel)) {
        porcentagem = this.transmitentes;
      } else {
        return ''
      }
      let participacao = Utils.truncateNumber(e.fracao || 0, 10) * 100 / Utils.truncateNumber(porcentagem, 10);
      e.participacaoDoi = Utils.truncateNumber(participacao, 10);
    },

    recalcularParticipacaoDoi(){
      if(this.exibirParticipacaoDoi){
        this.ato.envolvidos.forEach(envolvido =>{
          this.participacao(envolvido);
        })
      }
    },
    calculoInicialParticipacaoDoi(){
      let participacaoZerada = this.ato.envolvidos.every(objeto => objeto.participacaoDoi === 0);
      if(participacaoZerada){
        this.recalcularParticipacaoDoi();
      }
    },
    somatoriaParticipacao(isAdquirente){
      let listaPapeis = isAdquirente ? this.papeisAdquirentes : this.papeisTransmitentes;
      let soma = 0;
      if(listaPapeis.length > 0){
        this.ato.envolvidos.forEach(e =>{
          if(listaPapeis.includes(e.papel)){
            soma = Utils.toNumber(soma) + Utils.toNumber(e.participacaoDoi || 0);
          }
        })
      }
      return Utils.toNumber(soma, 2);
    },

    async gerarFirma(id, i) {
      if (!FrontBusiness.checkRequiredPermission(this.$root, 'PERMITIR_GERAR_CODIGO_FIRMA', 'Permissão requerida não encontrada: Permitir gerar código de firma')) return;
      if (this.processando) return;
      this.processando = true;
      try {
        await this._processarFirmaParaEnvolvido(id, i);
      } catch (e) {
        FrontBusiness.showError('', e.message);
      } finally {
        this.processando = false;
      }
    },

    async _processarFirmaParaEnvolvido(id, i) {
      let validacao = await IndicadorPessoalBusiness.validarFirma(id);
      let { editaveis, somenteNaoEditaveis } = FirmaPendenciasHelper.filtrarPendenciasEditaveis(validacao.bloqueios);

      if (somenteNaoEditaveis) {
        FrontBusiness.showError('', validacao.bloqueios.map(b => b.mensagem).join('\n'));
        return;
      }

      let mostrouAvisoPendencias = false;
      while (editaveis && editaveis.length > 0) {
        let codigosAnteriores = (editaveis || []).map(e => e.codigo).sort().join(',');
        let camposPendentes = FirmaPendenciasHelper.mapearCamposPendentes(editaveis);
        if (!mostrouAvisoPendencias) {
          FrontBusiness.showWarn('', 'Existem pendências para a geração da firma. Preencha os campos destacados.');
          mostrouAvisoPendencias = true;
        }
        let retorno = await FrontBusiness.openModal(FormIndicadorPessoal, {
          versaoId: id,
          camposPendentes
        });

        if (!retorno) return; // usuário cancelou o editor

        id = retorno.id;
        this.atualizar(i, {
          exigencias: this.ato.envolvidos[i].exigencias,
          indices: this.ato.envolvidos[i].indices,
          papel: this.ato.envolvidos[i]?.papel || this.papelPadrao,
          categoriaEnvolvido: this.ato.envolvidos[i]?.categoriaEnvolvido ?? '',
          fracao: this.ato.envolvidos[i].fracao || 0,
          participacaoDoi: this.ato.envolvidos[i].participacaoDoi || 0,
          area: this.ato.envolvidos[i].area || 0,
          ajusteDoi: this.ato.envolvidos[i].ajusteDoi || false,
          exibicao: this.ato.envolvidos[i].exibicao,
          exibicaoRepresentantePrincipal:this.ato.envolvidos[i].exibicaoRepresentantePrincipal,
          consultaCnib: this.ato.envolvidos[i].consultaCnib,
          dataConsultaCnib: this.ato.envolvidos[i].dataConsultaCnib,
          resultadoConsultaCnib: this.ato.envolvidos[i].resultadoConsultaCnib,
          consultaBib: this.ato.envolvidos[i].consultaBib,
          dataConsultaBib: this.ato.envolvidos[i].dataConsultaBib,
          gratuitoBib: this.ato.envolvidos[i].gratuitoBib,
          lei11441Bib: this.ato.envolvidos[i].lei11441Bib,
          consultasBib: this.ato.envolvidos[i].consultasBib || [],
          indicadorPessoalVersao: retorno,
          tipoPessoa: retorno.tipoPessoa,
          nome: retorno.nome,
          indicadorPessoalId: retorno.indicadorPessoalId,
          inventarianteVersao: this.ato.envolvidos[i].inventarianteVersao,
          inventariante: this.ato.envolvidos[i].inventariante,
          representantes:this.ato.envolvidos[i].representantes,
          tipoAssinatura: this.ato.envolvidos[i].tipoAssinatura,
          dedoAssinatura: this.ato.envolvidos[i].dedoAssinatura,
          dataAssinatura: this.ato.envolvidos[i].dataAssinatura,
          comunicar: this.ato.envolvidos[i].comunicar,
        });

        validacao = await IndicadorPessoalBusiness.validarFirma(id);
        let resultado = FirmaPendenciasHelper.filtrarPendenciasEditaveis(validacao.bloqueios);

        let codigosAtuais = (resultado.editaveis || []).map(e => e.codigo).sort().join(',');
        if (codigosAnteriores === codigosAtuais) {
          FrontBusiness.showWarn('', 'Nenhuma pendência foi resolvida. Preencha os campos destacados e salve novamente.');
        }

        editaveis = resultado.editaveis;

        if (resultado.somenteNaoEditaveis) {
          FrontBusiness.showError('', validacao.bloqueios.map(b => b.mensagem).join('\n'));
          return;
        }
      }

      if (validacao.alertas && validacao.alertas.length > 0) {
        for (let alerta of validacao.alertas) {
          let confirmou = await FrontBusiness.openConfirmacao(alerta.mensagem, 'Deseja continuar a geração da firma?');
          if (confirmou !== 'confirm') return;
        }
      }

      let {firma} = await IndicadorPessoalBusiness.gerarFirma(id, this.ato.id);
      this.ato.envolvidos[i].indicadorPessoalVersao.firma = firma;
      this.$forceUpdate();
    },

    async openDetalheIndicador(id, tipo) {
      await FrontBusiness.openModal(DetalhesIndicadorPessoal, {id, abaInicial: 'biometria-imagem-assinatura', tipo})
    }
  },

  beforeDestroy(){
    EventBus.$off('ADD-SUGESTAO-ENVOLVIDOS');
  }

}
</script>

<template>

  <card titulo="Envolvidos">

    <template #acoes>

      <a title="Sugestões" href v-if="edicao"
         @click.prevent="sugerirEnvolvidos()" class="icon ml-1">
        <i class="fa fa-users"></i>
      </a>

      <div class="d-flex float-right" v-if="papelComFracao" :style="'align-items: center;' + (edicao ? 'margin-top: -10px;' : '')">

        <span class="font-weight-500 small mr-2" v-if="ficha?.area && ato.dto.informarAreaEnvolvidos">Área total: {{$formatters.currency(ficha?.area,{min : 2, max : 10})}} {{unidadeArea}}</span>

        <div class="form-check form-check-inline form-group small float-right mb-0 mr-3" v-if="ficha?.livro == 'MATRICULA' || ficha?.livro == 'TRANSCRICAO'">
          <input class="form-check-input" id="informar-area" type="checkbox" style="margin-top: -1px;" :disabled="!edicao"
                 v-model="ato.dto.informarAreaEnvolvidos" @change="setMedidaAreaEnvolvidos">
          <label for="informar-area" class="form-check-label">Informar Área</label>
        </div>

        <v-button v-if="edicao" :run="calcularPorcentagem" :button="false" class="btn-outline-primary btn-sm btn small float-right mr-3">
          <i class="fas fa-calculator" title="Calcular Porcentagem"></i> Calcular Porcentagem
        </v-button>

        <v-button class="icon small float-right mr-1" :run="distribuirFracao" :button="false" :popover="true" position="dropleft" v-if="transmitentes && edicao">
          <i class="fas fa-divide" title="Distribuir fração transmitida"></i>
        </v-button>

        <div class="small float-right" style="cursor: help" title="Transmitentes & Adquirentes">
          <span class="text-right text-red"> {{$formatters.currency(transmitentes,{min : 2, max : 10})}}%</span>
          /
          <span class="text-right text-green">{{$formatters.currency(adquirentes,{min : 2, max : 10})}}%</span>
        </div>


        <div v-if="exibirParticipacaoDoi" style="margin-left: 10px" class="form-check form-check-inline form-group small float-right mb-0 mr-1">
          <label class="form-check-label">Participação: </label>
        </div>
        <div v-if="exibirParticipacaoDoi" class="small float-right" style="cursor: help;" title="Participação DOI">
          <span class="text-right text-red"> {{somatoriaParticipacao(false)}}%</span>
          /
          <span class="text-right text-green">{{somatoriaParticipacao(true)}}%</span>
        </div>



      </div>

    </template>

    <div>
      <p v-for="(validacao, i) in validacaoFracaoEnvolvido" :key="i" :class="'alert alert-' +validacao.cssClass+  ' mb-2'" title="Editar Ato" v-html="validacao.mensagem">
      </p>
      <div style="margin-top: -10px;" v-if="ato.envolvidos.length">
        <div class="text-muted cell-top" :class="{'pl-0' : edicao}" style="width: 100%">Pessoa</div>
        <div class="text-muted cell-top" style="min-width: 120px" v-if="isAberturaFirma">Firma</div>
        <div class="text-muted cell-top" style="min-width: 120px" v-if="isAtalhosPessoa"></div>
        <div class="text-muted cell-top" style="min-width: 180px" v-if="papeis.length > 0 && isProtocoloEspecialNotas">Categoria</div>
        <div class="text-muted cell-top" style="min-width: 180px" v-if="papeis.length > 0 && exibirPapel">Papel</div>
        <div class="text-muted cell-top" style="min-width: 150px" v-if="ato.dto.informarAreaEnvolvidos">{{ unidadeArea }}</div>
        <div class="text-muted cell-top" style="min-width: 150px" v-if="exibirFracao">Fração</div>
        <div class="text-muted cell-top" style="min-width: 150px" v-if="exibirParticipacaoDoi">Participação DOI</div>
        <div class="text-muted cell-top" style="min-width: 220px" v-if="isProtocoloEspecialNotas">Assinatura</div>
        <div class="text-muted cell-top" style="min-width: 200px" v-if="isProtocoloEspecialNotas">Dedo</div>
        <div class="text-muted cell-top" style="min-width: 150px" v-if="isProtocoloEspecialNotas && protocolo.registro">Data Assinatura</div>
        <div class="text-muted cell-top" style="min-width: 100px" v-if="exibirComunicar">Comunicar</div>
        <div class="text-muted cell-top" style="min-width: 34px"></div>
        <div class="text-muted cell-top" style="min-width: 34px"></div>
        <div class="text-muted cell-top" style="min-width: 34px" v-if="checklist.length"></div>
      </div>
      <div v-if="!ato.envolvidos.length" class="alert alert-outline-secondary alert-sm mb-1">
        Nenhuma parte envolvida cadastrada
      </div>
      <draggable class="table-envolvidos" v-if="ato.envolvidos.length" v-model="ato.envolvidos" handle=".move" ghost-class="ghost" @end="ordenar" :disabled="!edicao">
        <div v-for="(envolvido, i) in ato.envolvidos" class="row-e" :key="`${i}-${envolvido.indicadorPessoalId}`" :title="envolvido.ALERTA_DOCUMENTO" :class="{'ALERTA_DOCUMENTO': envolvido.ALERTA_DOCUMENTO}">
          <div class="cell move" style="width: 100%">
            <div>
              <a href class="mb-1 pointer icon mr-2" @click.prevent="detalhes(envolvido.indicadorPessoalVersao, envolvido.indicadorPessoalVersao.id)">
                {{envolvido.indicadorPessoalVersao.nome}} {{envolvido.indicadorPessoalVersao.versao ? `(Versão: ${envolvido.indicadorPessoalVersao.versao})` : ''}}</a>
              <a v-if="edicao" @click.prevent="editar(envolvido, i)" class="icon ml-1" title="Editar indicador pessoal"><i class="fal fa-edit"></i></a>
              <alert-indisponibilidade :pessoa="envolvido.indicadorPessoalVersao.indicadorPessoalId" />
              <alert-pep :pessoa="envolvido.indicadorPessoalVersao.indicadorPessoalId" />
              <alert-ocorrencia :pessoa="envolvido.indicadorPessoalVersao.indicadorPessoalId" />
            </div>

            <div class="small text-muted" v-if="envolvido.indicadorPessoalVersao.documento">

              {{envolvido.indicadorPessoalVersao.documento}}
              <span class="pointer" @click.prevent="copyDocumento(envolvido.indicadorPessoalVersao.documento)">
                <i class="icon ml-0 mr-1 far fa-copy"></i>
              </span>
            </div>

            <template v-if="isCustaAdicional && dominio === 'SERVICO_TN' && envolvido.tipoPessoa === 'JURIDICA'">
              <div class="mt-1 pt-1"></div>
              <div class="small text-muted">
                <span class="text-cyan" :class="{'pointer': edicao,'disabledClick': !edicao}" @click.prevent="editRepresentante(envolvido)">
                  ({{(envolvido.representantes || []).length > 0 ? `Representante: ${envolvido.exibicaoRepresentantePrincipal}` : 'Informar representante'}})
                  <i class="icon ml-1 far" :class="{'fa-angle-up' : envolvido.editandoRepresentante, 'fa-angle-down' : !envolvido.editandoRepresentante}"></i>
                </span>
                <a v-if="edicao" href class="icon ml-2" @click.prevent="adicionarRepresentante(envolvido)" title="Adicionar representante">
                  <i class="fas fa-user-plus"></i>
                </a>
              </div>

              <template v-if="envolvido.editandoRepresentante">
                <div class="w-100 mt-2 border-top border-gray pt-2"></div>
                <card-table v-if="(envolvido.representantes || []).length > 0" class="quadro-representantes">
                  <tr>
                    <th style="width: 50%">Representante</th>
                    <th style="width: 30%">Papel</th>
                    <th style="width: 20%; text-align: center">Selecionado</th>
                  </tr>
                  <tr v-for="representante in envolvido.representantes" :key="representante.indicadorPessoalVersaoId || representante.documento">
                    <td>{{ representante.nome || representante.documento }}</td>
                    <td>{{ representante.nomeTipoVinculo || '' }}</td>
                    <td style="text-align: center">
                      <input type="checkbox" v-model="representante.principal"
                             @change="selecionarRepresentanteServicoTn(envolvido, representante)" />
                    </td>
                  </tr>
                </card-table>
                <div v-else class="small text-muted mt-1">
                  Nenhuma pessoa cadastrada no quadro societário e representação
                </div>
              </template>
            </template>

            <template v-if="!isCustaAdicional">
              <div v-if="getExibirInventariante(envolvido)">
                <div class="mt- pt-1"></div>
                <div class="small text-muted">
                     <span style="color: cornflowerblue" :class="{'pointer': edicao,'disabledClick': !edicao}" @click.prevent="editInventariante(envolvido, i)">
                       ({{envolvido.inventariante ? `Inventariante: ${envolvido.exibicao}` : 'Informar inventariante'}})
                       <i class="icon ml-1 far" :class="{'fa-angle-up' : envolvido.editandoInventariante, 'fa-angle-down' : !envolvido.editandoInventariante}"></i>
                     </span>
                </div>

                <template v-if="envolvido.editandoInventariante">
                  <div class="w-100 mt-2 border-top border-gray pt-2"></div>
                  <v-input v-if="!envolvido.inventariante" :disabled="!edicao" v-model="envolvido.inventariante" :small="true"
                           title="Editar inventariante">
                    <buscar-pessoa @add="selecionarInventariante(envolvido, $event)" :novo="true" ref="buscar" :placeholder="``" :masks="'###.###.###-##'">
                      <template #acoes>
                        <div class="col-auto ml-2" style="margin-top: -1px;">
                          <button class="btn btn-primary btn-xs "
                                  @click.prevent="validarDocumentos(envolvido, false)"
                                  type="button">OK
                          </button>
                        </div>
                      </template>
                    </buscar-pessoa>
                  </v-input>
                  <div v-else class="row gutters-xs">
                    <v-input class="col form-group" :class="{'invalido': envolvido.inventarianteDocumentoInvalido && envolvido.inventariante, 'valido': !envolvido.inventarianteDocumentoInvalido && envolvido.inventariante}">
                      <input type="text" readonly :title="envolvido.exibicao" v-model="envolvido.exibicao" class="form-control form-control-xs"/>
                    </v-input>
                    <div class="col-auto">
                      <button class="btn btn-outline-secondary btn-xs" @click="selecionarInventariante(envolvido)" type="button" title="Remover">
                        <i class="fal fa-times"></i>
                      </button>
                    </div>
                  </div>
                  <label class="small text-danger-soft" style="color: #dc3545 !important" v-if="envolvido.inventarianteDocumentoInvalido && envolvido.inventariante">{{envolvido.inventarianteDocumentoInvalido}}</label>
                </template>
              </div>


              <div class="mt- pt-1"></div>
              <div class="small text-muted">
                <span class="text-teal" :class="{'pointer': edicao,'disabledClick': !edicao}" @click.prevent="editHashCNIB(envolvido, i)">
                  ({{envolvido.cnib ? `CNIB: ${cnibSubStr(envolvido)}` : 'Informar hash da consulta CNIB'}})
                  <span v-if="envolvido.cnib" class="pointer" title="Copiar hash CNIB" @click.prevent.stop="copyHashCNIB(envolvido)">
                    <i class="icon ml-0 mr-1 far fa-copy"></i>
                  </span>
                  <i class="icon ml-1 far" :class="{'fa-angle-up' : envolvido.editandoHashCNIB, 'fa-angle-down' : !envolvido.editandoHashCNIB}"></i>
                </span>
              </div>

              <template v-if="envolvido.editandoHashCNIB">
                <div class="w-100 mt-2 border-top border-gray pt-2"></div>
                <div v-if="!envolvido.cnib" :disabled="!edicao" class="input-group" :small="true" title="Editar CNIB">
                  <input type="text" :title="envolvido.consultaCnib" v-model="envolvido.consultaCnib" class="form-control form-control-xs"/>
                  <div class="ml-2" style="margin-top: -1px;">
                    <button class="btn btn-primary btn-xs "
                            @click.prevent="inserirCnib(envolvido, false)"
                            type="button">OK
                    </button>
                  </div>
                </div>

                <div v-else class="row gutters-xs">
                  <v-input class="col form-group">
                    <input type="text" readonly :title="envolvido.consultaCnib" v-model="envolvido.consultaCnib" class="form-control form-control-xs"/>
                  </v-input>
                  <div class="col-auto">
                    <button class="btn btn-outline-secondary btn-xs mr-1" @click="copyHashCNIB(envolvido)" type="button" title="Copiar hash CNIB">
                      <i class="far fa-copy"></i>
                    </button>
                    <button class="btn btn-outline-secondary btn-xs" @click="removerCnib(envolvido)" type="button" title="Remover">
                      <i class="fal fa-times"></i>
                    </button>
                  </div>
                </div>

                <div v-if="envolvido.cnib" class="row gutters-xs mt-2">
                  <div class="col-md-6">
                    <v-input v-model="envolvido.dataConsultaCnib" label="Data/horário da consulta"
                             type="datetime-local" :disabled="!edicao" />
                  </div>
                  <div class="col-md-6">
                    <v-input v-model="envolvido.resultadoConsultaCnib" label="Resultado da consulta"
                             type="select" :disabled="!edicao"
                             :options="[{id: 'POSITIVA', nome: 'Positiva'}, {id: 'NEGATIVA', nome: 'Negativa'}]" />
                  </div>
                </div>
              </template>

            </template>

            <EnvolvidoBib v-if="exibirBib" :envolvido="envolvido" :edicao="edicao" @toggle-bib="fecharOutrosBib" />
          </div>
          <div class="cell move" style="min-width: 120px" v-if="isAberturaFirma && envolvido.tipoPessoa !== 'JURIDICA'">
            <div class="d-flex align-items-center" v-if="envolvido.indicadorPessoalVersao?.firma">
              {{envolvido.indicadorPessoalVersao?.firma}}
              <FirmaBotoes v-if="edicao" :versao-id="envolvido.indicadorPessoalVersao.id" :servico-id="ato.id"/>
            </div>
            <v-button v-else-if="edicao" :params="[envolvido.indicadorPessoalId, i]" :popover="true"
                      :run="gerarFirma" class="icon btn-sm btn-outline-primary" position="dropleft">
              GERAR FIRMA
            </v-button>
          </div>
          <div class="cell move" style="min-width: 120px" v-if="isAtalhosPessoa && envolvido.tipoPessoa !== 'JURIDICA'">
            <div class="d-flex align-items-center justify-content-end">
              <v-button :run="openDetalheIndicador" :params="[envolvido.indicadorPessoalId, 'Biometria']" :button="false" class="icon ml-3" title="Biometria">
                <i class="fal fa-fingerprint"></i>
              </v-button>
              <v-button :run="openDetalheIndicador" :params="[envolvido.indicadorPessoalId, 'Imagem']" :button="false" class="icon ml-3" title="Imagem">
                <i class="fal fa-images"></i>
              </v-button>
              <v-button :run="openDetalheIndicador" :params="[envolvido.indicadorPessoalId, 'Assinatura']" :button="false" class="icon ml-3" title="Assinatura">
                <i class="fal fa-signature"></i>
              </v-button>
            </div>
          </div>

          <template v-if="!isCustaAdicional || exibirPapel">
            <div class="cell move" style="min-width: 180px" v-if="papeis.length > 0 && isProtocoloEspecialNotas">
              <v-input @change="emitChange(i)" :disabled="!edicao" v-model="envolvido.categoriaEnvolvido" type="select" placeholder="Nenhum" :options="categoriasEnvolvido" />
            </div>

            <div class="cell move" style="min-width: 180px" v-if="papeis.length > 0 && exibirPapel">
              <v-input @change="emitChange(i)" :idindice="`ENVOLVIDO_PAPEL_${envolvido.indicadorPessoalId}`" :disabled="!edicao" v-model="envolvido.papel" type="select" ref="papel" :options="papeis" />
            </div>

            <template v-if="!isCustaAdicional">
              <div class="cell move row pr-2" style="min-width: 150px" v-if="ato.dto.informarAreaEnvolvidos">
                <template v-if="papeisComFracao.includes(envolvido.papel)">
                  <v-input v-model="envolvido.area" type="currency" placeholder="Área"
                           @blur="verificarArea(envolvido, i)" class="col-10 float-left pl-0 pr-2"
                           :input-props="{precision : {min : 2, max : 10}}" :disabled="!edicao"/>

                  <div class="ato-action float-left mt-1" v-if="edicao">
                    <a href title="Calcular Fração" class="icon small" @click.prevent.stop="calcularFracao(envolvido)">
                      <i class="fal fa-calculator"></i>
                    </a>
                  </div>
                </template>
              </div>

              <div class="cell move" style="min-width: 150px" v-if="exibirFracao">
                <v-input :disabled="!edicao" v-model="envolvido.fracao" type="currency"
                         @blur="verificarFracao(envolvido, i)" placeholder="Fração" :input-props="{precision : {min : 2, max : 10}}"
                         v-if="papeisComFracao.includes(envolvido.papel)"
                         @input="recalcularParticipacaoDoi">
                </v-input>
              </div>

              <div class="cell move" style="min-width: 150px" v-if="exibirParticipacaoDoi">
                <v-input :disabled="!edicao" v-model="envolvido.participacaoDoi" type="currency" v-if="papeisParticipacaoDoi.includes(envolvido.papel)"
                         placeholder="Participação Doi" :input-props="{precision : {min : 2, max : 2}}">
                </v-input>
              </div>
            </template>
          </template>

          <div class="cell move" style="min-width: 220px" v-if="isProtocoloEspecialNotas">
            <v-input v-model="envolvido.tipoAssinatura" type="select" :options="tiposAssinatura"
                     placeholder="Assinatura" @input="salvarAssinatura(envolvido)">
            </v-input>
          </div>

          <div class="cell move" style="min-width: 200px" v-if="isProtocoloEspecialNotas">
            <v-input v-model="envolvido.dedoAssinatura" type="select" :options="dedosAssinatura"
                     placeholder="Dedo" :disabled="envolvido.tipoAssinatura !== 'ASSINA_A_ROGO'"
                     @input="salvarAssinatura(envolvido)">
            </v-input>
          </div>

          <div class="cell move" style="min-width: 150px" v-if="isProtocoloEspecialNotas && protocolo.registro">
            <v-input v-model="envolvido.dataAssinatura" type="date"
                     placeholder="Data" :disabled="envolvido.tipoAssinatura === 'NAO_ASSINA'"
                     @input="salvarAssinatura(envolvido)">
            </v-input>
          </div>

          <div class="cell move" style="min-width: 100px" v-if="exibirComunicar">
            <input type="checkbox" v-model="envolvido.comunicar" :disabled="!edicao" />
          </div>

          <div class="cell text-right" style="min-width: 34px">
            <div class="ato-action" v-if="edicao">
              <a href title="Duplicar" class="icon" @click.prevent.stop="duplicar(envolvido)">
                <i class="fal fa-clone"></i>
              </a>
            </div>
          </div>
          <div class="cell text-right" style="min-width: 34px">
            <div class="ato-action" v-if="edicao">
              <a @click.prevent="remover(i)" class="icon"><i class="fa fa-times"></i></a>
            </div>
          </div>
          <div class="cell td-toggle" style="min-width: 34px" v-if="checklist.length">
            <toggle :mostrar="chave(i) === mostrarChecklistEnvolvido" :run="change" :params="[i]" :chave="chave(i)" class="ml-2 icon" />
          </div>
          <div v-if="!isCustaAdicional && isProtocoloEspecialNotas" class="representante-secao float-left mb-3">
            <div class="representante-titulo">Representantes</div>

            <div v-if="edicao" class="representante-busca">
              <buscar-pessoa @add="selecionarRepresentante(envolvido, $event)" :novo="true" :placeholder="'Buscar representante...'" />
            </div>

            <div v-if="envolvido.representantes.length === 0" class="representante-vazio small text-muted">
              Nenhum representante informado
            </div>

            <template v-else>
              <div class="representante-linha representante-cabecalho">
                <div class="cell" style="width: 100%">
                  <div class="d-flex align-items-center">
                    <div class="rep-principal text-center">Principal</div>
                    <div>Representante</div>
                  </div>
                </div>
                <div class="cell" style="min-width: 180px" v-if="papeis.length > 0 && isProtocoloEspecialNotas"></div>
                <div class="cell" style="min-width: 180px" v-if="papeis.length > 0 && exibirPapel">Papel</div>
                <div class="cell" style="min-width: 150px" v-if="ato.dto.informarAreaEnvolvidos"></div>
                <div class="cell" style="min-width: 150px" v-if="exibirFracao"></div>
                <div class="cell" style="min-width: 150px" v-if="exibirParticipacaoDoi"></div>
                <div class="cell" style="min-width: 220px" v-if="isProtocoloEspecialNotas">Assinatura</div>
                <div class="cell" style="min-width: 200px" v-if="isProtocoloEspecialNotas">Dedo</div>
                <div class="cell" style="min-width: 150px" v-if="isProtocoloEspecialNotas && protocolo.registro">Data Assinatura</div>
                <div class="cell" style="min-width: 100px" v-if="exibirComunicar"></div>
                <div class="cell" style="min-width: 34px"></div>
                <div class="cell" style="min-width: 34px"></div>
                <div class="cell" style="min-width: 34px" v-if="checklist.length"></div>
              </div>

              <div class="representante-lista float-left w-100">
              <div v-for="(representante, ri) in envolvido.representantes" :key="'rep_'+ri" class="representante-linha">
                <div class="cell" style="width: 100%">
                  <div class="d-flex align-items-center">
                    <div class="rep-principal text-center">
                      <input type="checkbox" v-model="representante.principal" title="Principal" :disabled="!edicao"
                             @change="selecionarRepresentantePrincipal(envolvido, representante)" />
                    </div>
                    <div class="representante-nome">
                      <div>
                        <a v-if="representante.indicadorPessoalVersaoId" href class="pointer icon" @click.prevent="detalhesRepresentante(representante)">
                          {{representante.nome ? representante.nome : representante.documento}}</a>
                        <span v-else>{{representante.nome ? representante.nome : representante.documento}}</span>
                        <a v-if="edicao && representante.indicadorPessoalVersaoId" href @click.prevent="editarRepresentante(envolvido, representante)" class="icon ml-1" title="Editar indicador pessoal"><i class="fal fa-edit"></i></a>
                      </div>
                      <div v-if="representante.nome && representante.documento" class="small text-muted">
                        {{representante.documento}}
                        <span class="pointer" @click.prevent="copyDocumento(representante.documento)">
                          <i class="icon ml-0 mr-1 far fa-copy"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="cell" style="min-width: 180px" v-if="papeis.length > 0 && isProtocoloEspecialNotas"></div>
                <div class="cell" style="min-width: 180px" v-if="papeis.length > 0 && exibirPapel">
                  <v-input v-if="isProtocoloEspecialNotas" v-model="representante.papel" type="select" :options="papeis" placeholder="Papel"
                           :disabled="!edicao" @change="emitChange()" />
                </div>
                <div class="cell" style="min-width: 150px" v-if="ato.dto.informarAreaEnvolvidos"></div>
                <div class="cell" style="min-width: 150px" v-if="exibirFracao"></div>
                <div class="cell" style="min-width: 150px" v-if="exibirParticipacaoDoi"></div>
                <template v-if="isProtocoloEspecialNotas">
                  <div class="cell" style="min-width: 220px">
                    <v-input v-model="representante.tipoAssinatura" type="select" :options="tiposAssinatura"
                             placeholder="Assinatura" @input="salvarAssinaturaRepresentante(representante)" />
                  </div>
                  <div class="cell" style="min-width: 200px">
                    <v-input v-model="representante.dedoAssinatura" type="select" :options="dedosAssinatura"
                             placeholder="Dedo" :disabled="representante.tipoAssinatura !== 'ASSINA_A_ROGO'"
                             @input="salvarAssinaturaRepresentante(representante)" />
                  </div>
                  <div class="cell" style="min-width: 150px" v-if="protocolo.registro">
                    <v-input v-model="representante.dataAssinatura" type="date"
                             placeholder="Data" :disabled="representante.tipoAssinatura === 'NAO_ASSINA'"
                             @input="salvarAssinaturaRepresentante(representante)" />
                  </div>
                </template>
                <div class="cell" style="min-width: 100px" v-if="exibirComunicar"></div>
                <div class="cell" style="min-width: 34px"></div>
                <div class="cell text-right" style="min-width: 34px">
                  <a v-if="edicao" href @click.prevent="removerRepresentante(envolvido, representante)" class="icon representante-remover" title="Remover representante">
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <div class="cell" style="min-width: 34px" v-if="checklist.length"></div>
              </div>
              </div>
            </template>
          </div>
          <div style="background-color: rgb(28 30 36); width: 100%; padding-top: 5px;" class="float-left" v-if="chave(i) === mostrarChecklistEnvolvido">
            <responder-checklist :documentos="documentos"
                                 :checklists="checklist"
                                 :permitir-edicao="edicao"
                                 :envolvidos="[envolvido]"
                                 :dto="envolvido"
                                 ref="checklist" @exigencia="exibirExigencia(envolvido)"
            />
          </div>
        </div>
      </draggable>
      <div v-if="form && edicao" style="padding: 0.5rem 0.75rem;">
        <buscar-pessoa @add="selecionarEnvolvido($event)" :novo="true" id-input="buscar-pessoa" :filtros="filtrosEnvolvidos"/>
      </div>
    </div>
  </card>

</template>

<style lang=scss>
.invalido input{
  border-color: #dc3545 !important;
}

.valido input{
  border-color: #0e4e0e !important;
}

.disabledClick {
  pointer-events: none;
}

.ALERTA_DOCUMENTO {
  background-color: #a83d3426 !important;
}

.table-envolvidos {
  /*display: table;*/
  /*width: 100%;*/
  .row-e {
    /*display: table-row;*/
    vertical-align: inherit;
    border-color: inherit;
    background: rgb(35, 41, 49);

    .cell {
      display: table-cell;
      vertical-align: top;
      border-bottom: 5px solid #1c1e24;
      padding: 0.75rem;
      .form-group {
        margin-bottom: 0;
      }
    }
  }
}

.cell-top {
  display: table-cell;
  vertical-align: middle;
  padding: 0.75rem;
  font-weight: bold;
}


.representante-secao {
  width: 100%;
  margin-top: -5px;
  padding: 0 0 0.75rem;
  background: rgb(35, 41, 49);
  border-bottom: 5px solid #1c1e24;

  .representante-vazio {
    padding: 0.25rem 0.75rem;
  }

  .representante-titulo {
    padding: 0.25rem 0;
    margin: 0 0.75rem 0.5rem;
    font-size: 0.75rem;
    font-weight: 600;
    letter-spacing: 0.03em;
    color: #8b9096;
    border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  }

  .representante-busca {
    margin: 0 0.75rem 0.5rem;
  }

  .representante-cabecalho .cell {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    font-size: 0.75rem;
    font-weight: 600;
    color: #8b9096;
  }

  .representante-linha {
    .cell {
      vertical-align: middle;
      padding: 0.5rem 0.75rem;
      border-bottom: none;
    }

    &:nth-child(even) .cell {
      background: rgba(255, 255, 255, 0.03);
    }
  }

  .rep-principal {
    flex: 0 0 auto;
    width: 70px;
    padding-right: 0.5rem;
  }

  .representante-nome {
    min-width: 0;
    word-break: break-word;
    font-size: 0.9rem;
  }

  .representante-remover {
    color: #8b9096;

    &:hover {
      color: #dc3545;
    }
  }
}

.table-envolvidos .row-e .quadro-representantes {
  background: #232931;

  .table.table-card tbody tr {
    background: #232931;
    border-bottom: 5px solid #232931;
  }
}

.theme-light {
  .table-envolvidos {
    .row-e {
      background-color: #fff;
      .cell {
        border-bottom-color: #F1F1F2;
      }
    }
  }

  .representante-secao {
    background-color: #fff;
    border-bottom-color: #F1F1F2;

    .representante-titulo {
      border-bottom-color: rgba(0, 0, 0, 0.12);
    }

    .representante-linha:nth-child(even) .cell {
      background: rgba(0, 0, 0, 0.03);
    }
  }

  .table-envolvidos .row-e .quadro-representantes {
    background: #fff !important;

    .table.table-card tbody tr {
      background: #fff !important;
      border-bottom: 5px solid #fff !important;
    }
  }
}

</style>

